export  function differenceDaysBetweenTwoDates(fDate, sDate) {
    const date1 = fDate;
    const date2 = sDate;
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
  }